<template>
    <tile-question-layout v-if="panel_required"
                             :options_loaded="options_loaded"
                             :passed_filter="passed_filter"
                             :title="title"
                             :loading="loading"
                             v-model:target="localTarget"
                             :filtered_option_list="filtered_option_list"
                             :thumb_url="thumbURL"
                             :component_id="component_id"
                             :fabricator="fabricator"
                             :modifier_class="modifier_class"
    ></tile-question-layout>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalThreshold from "./DesignerQuestionTechnicalThreshold.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalThreshold,
        ],
        computed: {
            thumbURL() {
                return '/thumb/profile/';
            },
        },
    }
</script>
